import { motion } from "framer-motion";
import { InstagramLogo, FacebookLogo } from "@phosphor-icons/react";

const SOCIAL_LINKS = [
  {
    label: "Instagram",
    icon: InstagramLogo,
    url: "https://www.instagram.com/writtenbylogart/",
    testId: "footer-instagram",
  },
  {
    label: "Facebook",
    icon: FacebookLogo,
    url: "https://www.facebook.com/profile.php?id=61581552581370",
    testId: "footer-facebook",
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative py-16 md:py-20"
    >
      <div className="section-separator mb-16 md:mb-20" />

      <div className="max-w-6xl mx-auto px-6 md:px-12">
        {/* Follow CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <p
            className="text-sm tracking-widest uppercase mb-3"
            style={{
              fontFamily: "'Outfit', sans-serif",
              fontWeight: 400,
              color: "var(--text-secondary)",
              letterSpacing: "0.15em",
            }}
          >
            Stay Connected
          </p>
          <h3
            className="text-2xl sm:text-3xl mb-2"
            style={{
              fontFamily: "'Playfair Display', serif",
              fontWeight: 400,
              color: "var(--text-primary)",
            }}
          >
            Follow the <span style={{ color: "var(--gold)" }}>Journey</span>
          </h3>
          <p
            className="text-sm max-w-sm mx-auto mt-4"
            style={{
              fontFamily: "'Outfit', sans-serif",
              fontWeight: 300,
              color: "var(--text-secondary)",
              lineHeight: 1.7,
            }}
          >
            Follow writtenbylogart on social media for updates on new stories, behind-the-scenes moments, and more.
          </p>
        </motion.div>

        {/* Social icons */}
        <motion.div
          initial={{ opacity: 0, y: 15 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="flex justify-center gap-6 mb-16"
        >
          {SOCIAL_LINKS.map((social) => (
            <a
              key={social.testId}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={social.testId}
              className="flex items-center gap-3 px-6 py-3 rounded-sm transition-all duration-300 no-underline"
              style={{
                border: "1px solid rgba(234,208,161,0.12)",
                color: "var(--text-secondary)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = "rgba(234,208,161,0.3)";
                e.currentTarget.style.color = "var(--gold)";
                e.currentTarget.style.transform = "translateY(-2px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = "rgba(234,208,161,0.12)";
                e.currentTarget.style.color = "var(--text-secondary)";
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              <social.icon size={22} weight="light" />
              <span
                className="text-sm tracking-wide"
                style={{
                  fontFamily: "'Outfit', sans-serif",
                  fontWeight: 400,
                  letterSpacing: "0.05em",
                }}
              >
                {social.label}
              </span>
            </a>
          ))}
        </motion.div>

        {/* Bottom bar */}
        <div
          className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4"
          style={{
            borderTop: "1px solid rgba(234,208,161,0.08)",
          }}
        >
          <p
            className="text-xs"
            style={{
              fontFamily: "'Outfit', sans-serif",
              fontWeight: 300,
              color: "var(--text-secondary)",
              opacity: 0.6,
            }}
          >
            &copy; {new Date().getFullYear()} Ulrika Logart. All rights reserved.
          </p>
          <a
            href="https://www.goodreads.com/author/show/60231573.Ulrika_Logart"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-goodreads"
            className="text-xs no-underline transition-colors duration-300"
            style={{
              fontFamily: "'Outfit', sans-serif",
              fontWeight: 300,
              color: "var(--text-secondary)",
              opacity: 0.6,
            }}
            onMouseEnter={(e) => {
              e.target.style.color = "var(--gold)";
              e.target.style.opacity = 1;
            }}
            onMouseLeave={(e) => {
              e.target.style.color = "var(--text-secondary)";
              e.target.style.opacity = 0.6;
            }}
          >
            Goodreads
          </a>
        </div>
      </div>
    </footer>
  );
}
